module.exports = __webpack_public_path__ + "img/大图--日系.060d6bb3.png";